import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'



export const getPengalamanContent = createAsyncThunk('/pengalaman/content', async () => {
    const userId = localStorage.getItem("userId")
    const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/listCompanyClientFile/${userId}`, {})
    return response.data;
})

export const pengalamanSlice = createSlice({
    name: 'pengalaman',
    initialState: {
        isLoading: false,
        pengalaman : []
    },
    reducers: {


        addNewPengalaman: (state, action) => {
            let {newPengalamanObj} = action.payload
            state.pengalaman = [...state.pengalaman, newPengalamanObj]
        },

        deletePengalaman: (state, action) => {
            let {index} = action.payload
            state.pengalaman.splice(index, 1)
        }
    },

    /*extraReducers: {
        [getPengalamanContent.pending]: state => {
			state.isLoading = true
		},
        [getPengalamanContent.fulfilled]: (state, action) => {
            state.pengalaman = action.payload.data
			state.isLoading = false
		},
        [getPengalamanContent.rejected]: state => {
			state.isLoading = false
		},
    }*/
   
    extraReducers: (builder) => {       
        builder     
        .addCase(getPengalamanContent.pending, (state) => {
            state.isLoading = true
        })
        .addCase(getPengalamanContent.fulfilled, (state, action) => {
            state.pengalaman = action.payload.data
            state.isLoading = false
        })
        .addCase(getPengalamanContent.rejected, (state) => {
            state.isLoading = false
        })
    }   
})

export const { addNewPengalaman, deletePengalaman } = pengalamanSlice.actions

export default pengalamanSlice.reducer